/*    
<summary>
   This file is used to provide initial values or state to the User Module observables.
    Developer:Aashish Singh, Created Date:29-August-2023
</summary>
*/


import { ICustomerListVM } from "../../models/response/ICustomerManagementResponse";



export const initialState: ICustomerListVM = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    CustomerList: []
}